import React from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from "classnames";

class ShoppingHeader extends React.Component {
    render() {
        return (
            <>
                <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
                    <Container fluid>
                        <div className="header-body mx-3">
                            <Row>
                                <Nav
                                    className="nav-fill flex-column flex-md-row"
                                    id="tabs-icons-text"
                                    pills
                                    role="tablist"
                                >
                                    <NavItem>
                                        <NavLink
                                            aria-selected={this.props.tabs === 1}
                                            className={classnames("mb-sm-3 mb-md-0", {
                                                active: this.props.tabs === 1
                                            })}
                                            onClick={e => this.props.toggleNavs(e, "tabs", 1)}
                                            href="#pablo"
                                            role="tab"
                                        >
                                            Daftar Belanja
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            aria-selected={this.props.tabs === 2}
                                            className={classnames("mb-sm-3 mb-md-0", {
                                                active: this.props.tabs === 2
                                            })}
                                            onClick={e => this.props.toggleNavs(e, "tabs", 2)}
                                            href="#pablo"
                                            role="tab"
                                        >
                                            Belanja Sekarang
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Row>
                        </div>
                    </Container>
                </div>
            </>
        );
    }
}

export default ShoppingHeader;
